module.exports = __webpack_public_path__ + "img/play.013e43c0.svg";